import { useMemo, useState } from "react";
import { Select } from "antd";
import PageHeader from "@/components/PageHeader";
import PageTitle from "@/components/PageTitle";
import Page from "@/components/Page";
import PageContent from "@/components/PageContent";
import useRole from "@/auth/hooks/useRole";
import PageTabs from "@/components/PageTabs";
import LookupTab from "@/lookups/components/LookupTab";

const safetyValveTabItems = [
  {
    key: "Valve Data",
    label: "Valve Data",
    children: <LookupTab lookupType="SAFETY_VALVE" tabKey="Valve Data" />,
  },
  {
    key: "Pre Test Data",
    label: "Pre Test Data",
    children: <LookupTab lookupType="SAFETY_VALVE" tabKey="Pre Test Data" />,
  },
  {
    key: "Parts",
    label: "Parts",
    children: <LookupTab lookupType="SAFETY_VALVE" tabKey="Parts" />,
  },
  {
    key: "Final Test",
    label: "Final Test",
    children: <LookupTab lookupType="SAFETY_VALVE" tabKey="Final Test" />,
  },
];

const manualValveTabItems = [
  {
    key: "Valve Data",
    label: "Valve Data",
    children: <LookupTab lookupType="MANUAL_VALVE" tabKey="Valve Data" />,
  },
  {
    key: "Final Test",
    label: "Final Test",
    children: <LookupTab lookupType="MANUAL_VALVE" tabKey="Final Test" />,
  },
];

const Index = () => {
  const { isAdmin } = useRole();

  const [lookupType, setLookupType] = useState<"SAFETY_VALVE" | "MANUAL_VALVE">(
    "SAFETY_VALVE"
  );

  const tabItems = useMemo(() => {
    if (lookupType === "SAFETY_VALVE") {
      return safetyValveTabItems;
    }
    if (lookupType === "MANUAL_VALVE") {
      return manualValveTabItems;
    }
    throw new Error("Unexpected lookupType value");
  }, [lookupType]);

  const [tabKey, setTabKey] = useState(() => tabItems[0]?.key || "");
  const activeTab = tabItems.find((item) => item.key === tabKey);

  return (
    <Page>
      <PageHeader withTabs>
        <PageTitle title="Lookups" />
        <div>
          <Select
            value={lookupType}
            onChange={(value) => {
              setLookupType(value);

              if (value === "SAFETY_VALVE") {
                setTabKey(safetyValveTabItems[0].key);
              } else if (value === "MANUAL_VALVE") {
                setTabKey(manualValveTabItems[0].key);
              }
            }}
            options={[
              {
                label: "Safety Valves",
                value: "SAFETY_VALVE",
              },
              {
                label: "Manual Valves",
                value: "MANUAL_VALVE",
              },
            ]}
          />
        </div>
        {isAdmin && (
          <PageTabs
            activeKey={tabKey}
            items={tabItems.map((item) => ({ ...item, children: undefined }))}
            onChange={setTabKey}
          />
        )}
      </PageHeader>
      <PageContent>{activeTab?.children}</PageContent>
    </Page>
  );
};

export default Index;
